<template>
  <b-form-radio
    :value="option.value"
    :key="option.text"
    :class="'label-' + option.value"
    class="form-color-radio"
  />
</template>

<script>
export default {
  name: "GradientOption",
  props: {
    option: Object,
  },
};
</script>

<style scoped lang="scss">
.form-color-radio {
  border-radius: 100% !important;
  width: 22px;
  height: 22px;
  border: 2px solid $color-white;
  padding: 0;
  margin: 4px 4px 4px 0;

  &.active {
    background-color: transparent;
    border-color: $color-white !important;
    box-shadow: 0 0 0 1.5px #e65d1d;
  }
}

.label-1 {
  background: #e76888;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #e76888),
    color-stop(100%, #a05da2)
  );
  background: linear-gradient(to bottom, #e76888 0%, #a05da2 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#e76888', endColorstr='#a05da2', GradientType=0);
}
.label-2 {
  background: #93bf3a;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #93bf3a),
    color-stop(100%, #3c8b40)
  );
  background: linear-gradient(to bottom, #93bf3a 0%, #3c8b40 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#93bf3a', endColorstr='#3c8b40', GradientType=0);
}
.label-3 {
  background: #ef9546;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #ef9546),
    color-stop(100%, #e23e3b)
  );
  background: linear-gradient(to bottom, #ef9546 0%, #e23e3b 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#ef9546', endColorstr='#e23e3b', GradientType=0);
}
.label-4 {
  background: #36a8e1;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #36a8e1),
    color-stop(0%, #f16f5c),
    color-stop(100%, #1d72b8)
  );
  background: linear-gradient(to bottom, #36a8e1 0%, #f16f5c 0%, #1d72b8 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#36a8e1', endColorstr='#1d72b8', GradientType=0);
}
.label-5 {
  background: #be1622;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #be1622),
    color-stop(0%, #be1622),
    color-stop(100%, #2d2f83)
  );
  background: linear-gradient(to bottom, #be1622 0%, #be1622 0%, #2d2f83 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#be1622', endColorstr='#2d2f83', GradientType=0);
}
.label-6 {
  background: #951b81;
  background: -webkit-gradient(
    left top,
    left bottom,
    color-stop(0%, #951b81),
    color-stop(0%, #951b81),
    color-stop(100%, #29235c)
  );
  background: linear-gradient(to bottom, #951b81 0%, #951b81 0%, #29235c 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#951b81', endColorstr='#29235c', GradientType=0);
}
</style>
